<template style="height: 100%;">
  <div class="Details">
    <div class="activity_Details">
      
      <div style="font-family: SourceHanSansSC;font-size: 18px;color: rgb(51, 51, 51);font-style: normal;letter-spacing: 0px;text-decoration: none;margin-left: 20px;padding-bottom: 10px;font-weight: 700;margin-top: 10px;">
        {{ DetailsList.subject }}
        <!-- <span style="font-size: 13px;padding: 5px;color: rgba(24, 139, 255, 1);background-color: rgb(223, 239, 255);">{{ DetailsList.state }}</span> -->
      </div>
      <div class="spanstyle" style="line-height:20px">
        <span>活动类型：{{ DetailsList.eventType == 1?'体验型活动':'治疗性活动' }}</span>
        <span>活动人数：{{ DetailsList.signNum }}人</span>
        <span v-if="DetailsList.eventRate == 1">活动形式：单次</span>
        <span v-if="DetailsList.eventRate == 1">举办时间：{{ DetailsList.eventStartTime }} 日 {{ DetailsList.eventStartTiming  }} - {{ DetailsList.eventEndTime }} 日 {{ DetailsList.eventEndTiming }}</span>
        <span v-if="DetailsList.eventRate == 2">活动形式：连续</span>
        <span v-if="DetailsList.eventRate == 2" v-for="(item,i) in DetailsList.tget" :key="i">举办时间{{i+1}}：{{ item.eventStartTimeString }} 日 {{ item.eventStartTiming  }} - {{ item.eventEndTimeString }} 日 {{ item.eventEndTiming }}</span>
        <span>报名时间：{{ DetailsList.signStartTime }} - {{ DetailsList.signEndTime }}</span>
        <br />
      </div>
      <div class="spanstyle">
        <span>活动地址：{{ DetailsList.address }}</span>
        <span>活动负责人：{{ DetailsList.chargePerson }}</span>
      </div>
    </div>
    <div class="tabs" ref="divWidth">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="概况信息" name="first">
          <div style="font-family: SourceHanSansSC;font-weight: 700;font-size: 18px;color: rgb(16, 16, 16);font-style: normal;letter-spacing: 0px;text-decoration: none;padding-bottom: 10px;">
            基本信息
          </div>
          <div class="cotent">
            <table style="width: 100%;border-spacing: 0px">
              <tr style="height: 70px">
                <td class="title" width="20%">活动内容：</td>
                <td colspan="3">{{ DetailsList.evenContent }}</td>
              </tr>
              <tr>
                <td class="title" width="20%">预报名</td>
                <td width="30%">
                  {{ DetailsList.preSignFlg == "0" ? "不需要" : "需要" }}
                </td>
                <td class="title" width="20%">活动预算</td>
                <td width="30%">{{ DetailsList.eventBudget }}</td>
              </tr>
              <tr>
                <td class="title" width="20%">招募志愿者</td>
                <td width="30%">
                  {{DetailsList.volunteerFlg == "0"? "不招募": "招募"}}
                </td>
                <td class="title" width="20%">限制报名人数</td>
                <td width="30%">{{ DetailsList.preSignNum }}</td>
              </tr>
              <tr>
                <td class="title" width="20%">评分人数</td>
                <td width="30%">{{ DetailsList.scoreCount }}</td>
                <td class="title" width="20%">签到人数</td>
                <td width="30%">{{ DetailsList.signCount }}</td>
              </tr>
              <tr>
                <td class="title" width="20%">活动评分</td>
                <td width="30%">{{ DetailsList.score }}</td>
                <td class="title" width="20%">点赞人数</td>
                <td width="30%">{{ DetailsList.likeCount }}</td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="预报名" name="second" style="background-color: #fff">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-button type="primary" @click="SecondConsent()">同意报名</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="secondName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query1()">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table ref="multipleTable" :data="BeforehandData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSecondSelection" :row-key="(row) => { return row.eventRegisterKey; }">
            <el-table-column type="selection"  width="55" :selectable="selected"></el-table-column>
            <el-table-column prop="userID"     label="账号"></el-table-column>
            <el-table-column prop="realName"   label="姓名"></el-table-column>
            <el-table-column prop="sex"        label="性别"></el-table-column>
            <el-table-column prop="degree"     label="年级"></el-table-column>
            <el-table-column prop="deptName"   label="单位"></el-table-column>
            <el-table-column prop="creditRate" label="信用等级"></el-table-column>
            <el-table-column prop="paperScore" label="调查表">
              <template slot-scope="scope">
                <span>{{ scope.row.paperScore }}分</span>
              </template>
            </el-table-column>
            <el-table-column prop="statusStr" label="报名状态"></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="scope.row.statusStr == '待审核'">
                  <span style="color: rgb(24, 144, 255);" @click="UpdateApply(scope.row.eventRegisterKey,2)">通过</span>
                  <span style="color: rgb(24, 144, 255);margin-left: 10px;" @click="UpdateApply(scope.row.eventRegisterKey,3)">不通过</span>
                </div>
                <div v-else>
                  <span></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange1" :current-page.sync="pageIndex1" :page-size="pageSize1" layout="total, prev, pager, next" :total="Count1"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="报名列表" name="third" style="background-color: #fff">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-button type="primary" @click="daochu()">导出</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="thirdName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query2()">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table ref="multipleTable" :data="applyListData" tooltip-effect="dark" style="width: 100%">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column prop="userID"     label="学号"></el-table-column>
            <el-table-column prop="realName"   label="姓名"></el-table-column>
            <el-table-column prop="sex"        label="性别"></el-table-column>
            <el-table-column prop="degree"     label="学生层次"></el-table-column>
            <el-table-column prop="deptName"   label="单位"></el-table-column>
            <el-table-column prop="paperScore" label="调查表"></el-table-column>
            <el-table-column prop="statusStr"  label="报名状态"></el-table-column>
            <el-table-column prop="creditRate" label="信用等级"></el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange2"  :current-page.sync="pageIndex2" :page-size="pageSize2" layout="total, prev, pager, next" :total="Count2"
            v-if="Count2 > 0"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="志愿者" name="fourth" style="background-color: #fff">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-button type="primary" @click="fourthConsent()">同意报名</el-button>
              <el-button type="primary" @click="fourthConsentdaochu()">导出</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="fourthName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query3()">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table ref="multipleTable" :data="VolunteerList" tooltip-effect="dark" style="width: 100%" @selection-change="handleFourthSelection" :row-key="(row) => { return row.eventVolunteerKey;}">
            <el-table-column type="selection" width="55" :selectable="selected2"> </el-table-column>
            <el-table-column prop="userID"   label="账号"> </el-table-column>
            <el-table-column prop="realName" label="姓名"> </el-table-column>
            <el-table-column prop="sex"      label="性别"> </el-table-column>
            <el-table-column prop="degree"   label="学历"> </el-table-column>
            <el-table-column prop="deptID"   label="单位"> </el-table-column>
            <!-- <el-table-column prop="volunteerTypeStr" label="志愿者类型"> </el-table-column> -->
            <el-table-column prop="paperScore" label="调查表"></el-table-column>
            <!-- <el-table-column prop="statusStr"   label="报名状态"> </el-table-column> -->
            <el-table-column prop="status" label="报名状态"> 
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待审批</span>
                <span v-if="scope.row.status == 2">已通过</span>
                <span v-if="scope.row.status == 3">拒绝</span>
                <span v-if="scope.row.status == 4">取消</span>
              </template>
            </el-table-column>
            <el-table-column prop="creditLevel" label="信用等级"></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <div v-if="scope.row.status == '1'">
                  <span style="color: rgb(24, 144, 255);" @click="UpdateEventVolunteer(scope.row,2)">同意</span>
                  <span style="color: rgb(24, 144, 255);margin-left: 10px;" @click="UpdateEventVolunteer(scope.row,3)">拒绝</span>
                </div>
                <div v-else>
                  <span></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange3" :current-page.sync="pageIndex3" :page-size="pageSize3" layout="total, prev, pager, next" :total="Count3"></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="签到" name="thefifth" style="background-color: #fff;">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="">
              <el-input v-model="thefifthName" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query4()">查询</el-button>
              <el-button type="primary" @click="query4daochu()">导出</el-button>
              <el-button type="primary" @click="xzbbfun(fornum)">选中颁发</el-button>
            </el-form-item>
          </el-form>
          <el-table ref="multipleTable" :data="SignInList" tooltip-effect="dark" row-key="userID" default-expand-all style="width: 100%" :tree-props="{ children: 'eventSign', hasChildren: 'hasChild' }" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55"></el-table-column>
            <el-table-column prop="userID"     label="学号"></el-table-column>
            <el-table-column prop="realName"   label="姓名"></el-table-column>
            <el-table-column prop="sex"        label="性别"></el-table-column>
            <el-table-column prop="degree"     label="学历"></el-table-column>
            <el-table-column prop="deptName"   label="单位"></el-table-column>
            <el-table-column prop="category"   label="人员类别">
              <template slot-scope="scope">
                <span>{{scope.row.category == 1?'活动报名':'志愿者报名'}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="isSignTime" label="活动次序"></el-table-column> -->
            <el-table-column prop="lastSignIn"      label="签到">    </el-table-column>
            <el-table-column prop="lastSignTime"    label="签到时间"></el-table-column>
            <el-table-column prop="lastSignOut"     label="签退">    </el-table-column>
            <el-table-column prop="lastSignOutTime" label="签退时间"></el-table-column>
            <el-table-column prop="lastScore"       label="评分">    </el-table-column>
            <el-table-column label="操作" show-overflow-tooltip width="160px">
              <template slot-scope="scope">
                <el-button v-if="scope.row.hasCert == '0'" type="text" @click="tgfun(scope.row)" :disabled = xsxs1>颁发证书</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange4" :current-page.sync="pageIndex4" :page-size="pageSize4" layout="total, prev, pager, next" :total="Count4"></el-pagination>


          <div ref="content" class="certificate" :style="{backgroundImage:'url('+imgurl+')'}">
            <img style="width: 40px;height: 40px;margin-top:40px;margin-left:32px;" src="../../assets/26e55c391edca1734eda330566f9810.png" alt="">
            <h3 style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:-42px;font-size: 13px;">中国科学院大学心理健康教育中心</h3>
            <p style="color: #fff;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;margin-left:80px;margin-top:0px;font-size: 10px;">Mental Health Education Center, UCAS</p>
            <h2 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 34px;letter-spacing:1px">课程证书</h2>
            <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">Certificate of completion</p>
            <h4 style="text-align:center;color: #fff;margin-top:20px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;font-size: 20px;">{{certificateContentdata.realName}}</h4>
            <p style="text-align:center;color: #fff;margin-top:10px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">身份证号:{{certificateContentdata.idCard}}</p>
            <p style="text-align:left;color: #fff;margin-top:10px;width: 86%;margin-left:7%;line-height:26px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">恭喜您于{{certificateContentdata.certTime}}，参加{{certificateContentdata.deptName}}举办的 “{{certificateContentdata.eventSubject}}”</p>
            <p style="text-align:left;color: #fff;margin-top:10px;margin-left:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;text-indent:24px;letter-spacing:1px">特发证书</p>
            <h5 style="text-align:right;color: #fff;margin-top:30px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;letter-spacing:1px">中国科学院大学心理健康教育中心</h5>
            <p style="text-align:right;color: #fff;margin-top:10px;margin-right:7%;font-size: 16px;font-family: 'SourceHanSerifCN-Bold-2',sans-serif !important;">{{formatChineseDateTime(new Date())}}</p>
          </div>


        </el-tab-pane>
        <el-tab-pane label="评价" name="review">
          <h2 style="font-size: 18px;padding-bottom: 10px;">用户评价 <span style="font-size: 14px;">({{reviewList.length}}条)</span></h2> 
          <ul class="review" style="height:100%;overflow: auto;">
            <li style="position: relative;height: 120px;" v-for="(item, i) in reviewList" :key="i">
              <img style="width: 30px;height: 30px;border-radius: 50%;position: absolute;top: 10px;left: 10px;" :src="item.zheadPhotoURL" alt="">
              <p style="position: absolute;top: 17px;left: 52px;">{{ item.creator }}</p>
              <p style="position: absolute;top: 50px;left: 52px;font-size: 14px;font-weight: 600;">{{item.comment}}</p>
              <p style="position: absolute;top: 80px;left: 52px;">{{ item.createTime }}<span class="w" @click="delreview(item)">删除评价</span></p>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="数据统计" name="sextus" style="width: 100%;height: 100%;background-color: rgb(235, 236, 237);overflow:auto;">
          <div style="width: 100%;height: 14px;background-color: rgb(235, 236, 237);"></div>
          <div ref="collegeStatistics" style="width:98%;height: 400px;background-color: #fff;margin-left:1%;"></div>
          <div ref="peopleNumList" style="width:49%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%;float: left;margin-top:14px"></div>
          <div ref="activityNum" style="width:48%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:14px"></div>
          <div ref="scoreNumByScore" style="width:49%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%;float: left;margin-top:14px;margin-bottom:20px"></div>
          <div ref="peopleNumByDegree" style="width:48%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:14px"></div>
        </el-tab-pane>
        <el-tab-pane label="活动交流" name="hdjl" style="width: 100%;height: 100%;background-color: rgb(235, 236, 237);overflow:auto;">
          <div style="width: 100%;height: 100%;background-color: #fff;">
            <el-form :inline="true" :model="hdjl" class="demo-form-inline">
              <el-form-item label="排序方式">
                <el-select v-model="hdjl.sort" placeholder="排序方式">
                  <el-option label="点赞最多" value="1"></el-option>
                  <el-option label="评价最多" value="2"></el-option>
                  <el-option label="时间倒序" value="3"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="审核状态">
                <el-select v-model="hdjl.auditStatus" placeholder="审核状态">
                  <el-option label="已通过" value="1"></el-option>
                  <el-option label="未通过" value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="活动时间">
                <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="hdjl.createTime" style="width: 100%;"></el-date-picker>
              </el-form-item>
              
              <el-form-item>
                <el-button type="primary" @click="jlcli()">查询</el-button>
                <el-button type="primary" @click="jlclicz()">重置</el-button>
              </el-form-item>
            </el-form>


            <div style="width: calc(100% - 500px);height: calc(100% - 70px);float: left;">
              <ul style="height: 100%;overflow:auto;height: calc(100% - 50px);">
                <li v-for="(item,i) in eventcommunicationlist" :key="i" style="width: 96%;margin-left:2%;height: 200px;border-bottom:1px solid rgb(215 215 215);position: relative;" @click ="looksfun(item)">
                  <img :src="item.cover" alt="" style="width: 200px;height: 140px;position: absolute;top:10px;left:20px">
                  <p style="position: absolute;top:10px;left:250px;line-height:26px;">{{item.remark}}</p>
                  <p style="position: absolute;bottom:40px;left:250px;line-height:26px;">
                    <span>上传者：{{item.creator}}</span> 
                    <span style="margin-left:10px;color: rgba(0, 136, 255, 1);"> {{item.subject}}</span>
                    <span style="margin-left:10px">点赞：{{item.likeCount}}</span>
                    <span style="margin-left:10px">评价：{{item.commentCount}}</span>
                    <span style="margin-left:10px">分享：{{item.shareCount}}</span>
                  </p>
                  <!--13:35auditstatus1审核通过2审核不通过0审核中-->
                  <!--status0下架1上架-->
                  <p v-if="item.status == 0" style="position: absolute;top:10px;right:20px;color: red;">已下架</p>
                  <el-button v-if="item.auditStatus == 0" type="primary" style="position: absolute;bottom: 40px;right: 195px;"  @click.stop="shnhefun(item.contentKey,1)">同意</el-button>
                  <el-button v-if="item.auditStatus == 0" type="primary" style="position: absolute;bottom: 40px;right: 100px;" @click.stop="shnhefun(item.contentKey,2)">不同意</el-button>
                  <el-button v-if="item.status == 1" style="position: absolute;bottom: 40px;right: 20px;"  @click.stop="xiajiafun(item.contentKey)">下架</el-button>
                </li>
              </ul>
              <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChangejl" :current-page.sync="hdjl.pageIndex" :page-size="hdjl.pageSize" layout="total, prev, pager, next" :total="hdjl.Count"></el-pagination>
            </div>


            <div v-for="(item,i) in looksfundata.contentPic" :key="i">
              <div v-if="item.materialStates == 1" style="width: 490px;height: calc(100% - 70px);float: left;position: relative;">

                <video id="video1" width="480" height="340" controls style="position: absolute;top:10px;left:20px;"  >
                  <source :src="item.materialPath" type="video/mp4"/>
                  <source :src="item.materialPath" type="video/avi"/>
                  <source :src="item.materialPath" type="video/mov"/>
                </video>

                <img :src="item.picPath" alt="" style="width: 50px;height: 50px;position: absolute;top:370px;left:20px;border-radius:50%;">
                <p style="position: absolute;top:370px;left:80px;font-size: 18px;">{{looksfundata.creator}}</p>
                <p style="position: absolute;top:400px;left:80px;font-size: 16px;">{{looksfundata.createTime}}</p>
                <p style="position: absolute;top:400px;font-size: 16px;right:0px">点赞量：{{looksfundata.likeCount}} 评价{{looksfundata.commentCount}}  </p>
                <p style="position: absolute;top:450px;font-size: 16px;right:0px;width: 470px;margin-left:10px">{{looksfundata.remark}}</p>

              </div>
            </div>

          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  components: { html2canvas },
  data() {
    return {
      xsxs1:false,
      looksfundata:'',
      eventcommunicationlist:[],
      hdjl:{
        sort:'',
        auditStatus:'',
        createTime:'',
        pageSize:10,
        pageIndex:1,
        sourceKey:'',
        Count:0,
      },
      certificateContentdata:'',
      tgfunload:true,
      fornum:1,
      stidata:[],
      datak:[],
      divWidth:'',
      Count1: 0,
      pageSize1: 10,
      pageIndex1: 1,
      Count2: 0,
      pageSize2: 10,
      pageIndex2: 1,
      Count3: 0,
      pageSize3: 10,
      pageIndex3: 1,
      Count4: 0,
      pageSize4: 10,
      pageIndex4: 1,
      thirdName: "",
      fourthName: "",
      thefifthName: "",
      activeName: "first",
      secondName: "", //第一个页面条件
      secondSelection: [], //预报名多选数组
      FourthSelection: [], //志愿者多选数组
      BeforehandData: [],
      applyListData: [],
      VolunteerList: [], //志愿者
      SignInList: [], //签到
      reviewList: [], //评价
      StatisticsList: [],
      DetailsList: {},
      EventNo: "",
      imgurl: "",
    };
  },
  methods: {
    xiajiafun(contentKey){
      var hu =  [contentKey]
      var form = {
        contentKeys:[contentKey],
        auditStatus:0
      } 

      this.$Http_Post("activitymanagement/qgcontent", {from: form}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.geteventcommunicationlist()
        } else {
          this.Global.request_failure(res.Message);
        }
      });


    },
    shnhefun(contentKey,type){
      var hu =  [contentKey]
      var form = {
        contentKeys:[contentKey],
        auditStatus:type
      } 

      this.$Http_Post("activitymanagement/auditcontent", {from: form}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.geteventcommunicationlist()
        } else {
          this.Global.request_failure(res.Message);
        }
      });

    },
    formatChineseDateTime(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      return `${year}年${month}月`;
    },
    handleSelectionChange(e){
      this.stidata = [];
      for(let item of e){
        this.stidata.push(item.eventSign[0].eventSignKey);
        this.datak.push(item.eventSign[0].userID);


        
      }
    },
    base64ToFile (base64Data,userID){
      // 将base64的数据部分提取出来
      const arr = base64Data.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // 将Uint8Array转换为Blob对象
      const blob = new Blob([u8arr], { type: mime });
      // 创建File对象
      const file = new File([blob], userID + '.png', { type: mime });
      return file;

    },
    looksfun(itme){
      this.looksfundata = itme
    },
    xzbbfun(num){
      if(this.stidata.length <=0){
        alert('请选择人员!')
        return false
      }
      var _this=this;
      if(num <= this.stidata.length){
        _this.$Http_Post('/activitymanagement/certificateContent', {eventSignKey:_this.stidata[num-1]}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            _this.certificateContentdata = res.Data;
            setTimeout(function(){
              html2canvas(_this.$refs.content,{scale:2}).then(canvas => {
                var img = canvas.toDataURL("image/jpg");
                var formData = new FormData();
                formData.append('images', _this.base64ToFile(img,_this.stidata[num-1]));
                _this.$Http_Post('AppUser/UpdatePortraitAndCertificate', formData).then((resw) => {
                  if (resw.Code == 200 || resw.Code == 0) {
                    if(_this.tgfunload){
                      _this.tgfunload = false;
                      _this.$Http_Post('edu/app/passCertificate', {stuID:_this.datak[num-1],trainId:_this.$route.query.id,certUrl:resw.Data,certType:'2',examMethod:'2'}).then((res) => {
                        if (res.Code == 200 || res.Code == 0) {
                          num ++;
                          _this.xzbbfun(num);
                          if(num>_this.stidata.length){
                            _this.Global.request_successful(res.Message);
                          }
                        } else {
                          _this.Global.request_failure(res.Message);
                        }
                        _this.tgfunload = true;
                      })
                    }
                  }
                })
              })
            },1000)
          }
        })
      }
    },

    tgfun(row){
      var _this=this;
      this.xsxs1 = true
      this.$Http_Post("activitymanagement/certificateContent", {eventSignKey: row.eventSign[0].eventSignKey}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.certificateContentdata = res.Data;
            setTimeout(function(){
              html2canvas(_this.$refs.content,{scale:2,type:'image/jpg'}).then(canvas => {
                var img = canvas.toDataURL("image/jpg");
                var formData = new FormData();
                formData.append('images', _this.base64ToFile(img,row.userID ))
                _this.$Http_Post('AppUser/UpdatePortraitAndCertificate', formData).then((resw) => {
                  if (resw.Code == 200 || resw.Code == 0) {
                    _this.stidata = row.userID;
                    if(_this.tgfunload){
                      _this.tgfunload = false;
                      _this.$Http_Post('edu/app/passCertificate', {stuID:_this.stidata,trainId:_this.$route.query.id,certUrl:resw.Data,certType:'2',examMethod:'1'}).then((res) => {
                        if (res.Code == 200 || res.Code == 0) {
                          _this.xsxs1 = false;
                          _this.Global.request_successful(res.Message);
                          _this.GetSignInList();
                        } else {
                          _this.Global.request_failure(res.Message);
                        }
                        _this.tgfunload=true;
                      })
                    }
                  }
                })
              })
            },1000)
          } else {
            this.Global.request_failure(res.Message);
          }
          this.tgfunload = true;
        });
//trainMethod 1上2下
    },

    query4() {
      this.pageSize4 = 10;
      this.pageIndex4 = 1;
      this.GetSignInList();
    },
    query3() {
      this.pageSize3 = 10;
      this.pageIndex3 = 1;
      this.GetVolunteerList();
    },
    query2() {
      this.pageSize2 = 10;
      this.pageIndex2 = 1;
      this.GetapplyList();
    },
    query1() {
      this.pageSize1 = 10;
      this.pageIndex1 = 1;
      this.GetBeforehand();
    },
    handleCurrentChangejl(val){
      this.hdjl.pageIndex = val;
      // this.geteventcommunicationlist();
      this.geteventcommunicationlist()
    },
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      this.GetBeforehand();
    },
    handleCurrentChange2(val) {
      this.pageIndex2 = val;
      this.GetapplyList();
    },
    handleCurrentChange3(val) {
      this.pageIndex3 = val;
      this.GetVolunteerList();
    },
    handleCurrentChange4(val) {
      this.pageIndex4 = val;
      this.GetSignInList();
    },

    selected(row, index) {
      if (row.statusStr != "待审核") {
        return false;//不可勾选
      } else {
        return true;//可勾选
      }
    },

    selected2(row, index) {
      if (row.status !== "1") {
        return false;//不可勾选
      } else {
        return true;//可勾选
      }
    },

    SecondConsent() {
      if (this.secondSelection.length == 0) {
        this.Global.request_failure("您未选中需要通过的人员信息！");
      } else {
        this.$Http_Post("/activitymanagement/updateeventregister", {eventRegisterKeys: this.secondSelection,status: '2'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.GetBeforehand();
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },

    delreview(item) {
      this.$Http_Post("/activitymanagement/deleventcontent", { eventLikeTranspondKey: item.eventLikeTranspondKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GetreviewList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    fourthConsent() {
      if (this.FourthSelection.length == 0) {
        this.Global.request_failure("您未选中需要通过的人员信息");
      } else {
        this.$Http_Post("/activitymanagement/updateeventvolunteer", {eventVolunteerKeys: this.FourthSelection,status: "2"}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.GetVolunteerList();
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },

    UpdateEventVolunteer(row, Status) {
      var EventNo = [];
      EventNo.push(row.eventVolunteerKey);
      this.$Http_Post("/activitymanagement/updateeventvolunteer",{eventVolunteerKeys: EventNo,status: Status}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GetVolunteerList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    UpdateApply(eventRegisterKey,vai) {
      var oops = [];
      oops.push(eventRegisterKey);
      this.$Http_Post("/activitymanagement/updateeventregister", {eventRegisterKeys: oops,status: vai}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GetBeforehand();
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },
    
    handleSecondSelection(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].eventRegisterKey);
      }
      this.secondSelection = lsc;
    },
    handleFourthSelection(val) {
      var lsc = [];

      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].eventVolunteerKey);
      }
      this.FourthSelection = lsc;
    },
    handleClick(tab, event) {
      if (tab.name == "second") {
        this.GetBeforehand();
      } else if (tab.name == "third") {
        this.GetapplyList();
      } else if (tab.name == "fourth") {
        this.GetVolunteerList();
      } else if (tab.name == "thefifth") {
        this.GetSignInList();
      } else if (tab.name == "sextus") {
        this.$nextTick(() => {
          this.GetStatisticsList();
        });
      } else if(tab.name == "review") {
        this.GetreviewList();
      }else if(tab.name == "hdjl") {
        this.geteventcommunicationlist()
        // this.handleCurrentChangejl();
      }
    },
    daochu() {
      this.$Http_Post("/activitymanagement/exportapplyList", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize2,pageIndex: this.pageIndex2,query: this.thirdName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },

    query4daochu() {
      this.$Http_Post("/activitymanagement/exportsigninlist", { eventKey: Number(this.$route.query.id), pageSize: this.pageSize2, pageIndex: this.pageIndex2, query: this.thirdName }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },

    GetreviewList() {
      this.$Http_Post("/activitymanagement/geteventcontentlist", { eventKey: Number(this.$route.query.id), pageSize: this.pageSize1, pageIndex: this.pageIndex1, query: this.secondName }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.reviewList = res.Data;
        }
      });
    },

    jlclicz(){
      this.hdjl = {
        sort:'',
        auditStatus:'',
        createTime:'',
        pageSize:10,
        pageIndex:1,
        sourceKey:'',
        Count:0,
      }
      this.geteventcommunicationlist();
    },
    jlcli(){
      this.hdjl.pageIndex = 1;
      this.geteventcommunicationlist();
    },
    
    geteventcommunicationlist() {
      this.$Http_Post("/activitymanagement/geteventcommunicationlist", { 
        sourceKey: Number(this.$route.query.id), 
        pageSize: this.hdjl.pageSize, 
        pageIndex: this.hdjl.pageIndex, 
        sort: this.hdjl.sort,
        auditStatus: this.hdjl.auditStatus,
        createTime: this.hdjl.createTime,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.eventcommunicationlist = res.Data;
          this.hdjl.Count = res.Counts;
        }
      });
    },

    GetBeforehand() {
      this.$Http_Post("/activitymanagement/getbeforehand", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize1,pageIndex: this.pageIndex1,query: this.secondName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.BeforehandData = res.Data;
          this.Count1 = res.Counts;
        }
      });
    },

    GetVolunteerList() {
      this.$Http_Post("/activitymanagement/getvolunteerlist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize3,pageIndex: this.pageIndex3,query: this.fourthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.VolunteerList = res.Data;
          this.Count3 = res.Counts;
        }
      });
    },

    fourthConsentdaochu() {
      this.$Http_Post("/activitymanagement/exportvolunteerlist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize3,pageIndex: this.pageIndex3,query: this.fourthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    GetapplyList() {
      this.$Http_Post("/activitymanagement/getapplylist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize2,pageIndex: this.pageIndex2,query: this.thirdName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.applyListData = res.Data;
          this.Count2 = res.Counts;
        }
      });
    },
    
    GetSignInList() {
      this.$Http_Post("/activitymanagement/getsigninlist", { eventKey: Number(this.$route.query.id),pageSize: this.pageSize4,pageIndex: this.pageIndex4,query: this.thefifthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.SignInList = res.Data;
          this.Count4 = res.Counts;
        }
      });
    },

    GetStatisticsList() {
      this.$Http_Post("/activitymanagement/getstatisticslist", { eventKey: Number(this.$route.query.id)}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.StatisticsList = res.Data;
          this.collegeStatistics(res.Data.collegeStatistics);
          this.peopleNumList(res.Data.peopleNumList);
          this.activityNum(res.Data.activityNum);
          this.scoreNumByScore(res.Data.scoreNumByScore);
          this.peopleNumByDegree(res.Data.peopleNumByDegree);
        }
      });
    },


    cscs() {
      this.$router.push('/Data/All_data');
    },


    
    collegeStatistics(data) {
      let list1 = [];
      let list2 = [];
      let list3 = [];
      for (var i = 0; i < data.length; i++){
        list1.push(data[i].deptName);
        list2.push(data[i].manCount);
        list3.push(data[i].womanCount);
      }
      var myChart = this.$echarts.init(this.$refs.collegeStatistics);
      var option = {
        title: {
          text: '各学院参加活动人数',
          left: '20px',
          top: '10px',
        },
        legend: {
          top:'20px',
          textStyle: {
            color: '#000',//字体颜色
          },
          itemHeight: 10,
        },
        color: ["#00bb7a","#ff9502"],
        tooltip: {
          trigger: 'axis',
          axisPointer: {//坐标轴指示器，坐标轴触发有效
            type: 'shadow'//默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: {
          type: 'category',
          nameTextStyle: {//y轴上方单位的颜色
            color: '#000'
          },
          axisLabel: {
            show: true,
            color: '#000',
            fontSize: 12
          },
          data: list1
          // data: ['Mon', 'Tue', 'Wed', 'Thu']
        },
        
        yAxis: {
          type: 'value',
          splitLine: { //网格线
            lineStyle: {
              type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
            }
          }
        },
        series: [
          { type: 'bar',name: '男', barWidth: 20, data: list2 },
          { type: 'bar',name: '女', barWidth: 20, data: list3 }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    peopleNumList(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumList);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'//'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        title: {
          text: '报名/签到/评分人数统计',
          left: '20px',
          top: '10px',
        },
        color: ["#00bb7a","#ff9502"],
        legend: {
          top: '10px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['报名人数', '签到人数', '评分人数']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '男',
            type: 'bar',
            barWidth: 30,
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: data.map(item =>item==null?0:item.manCount)
          },
          {
            name: '女',
            type: 'bar',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: data.map(item =>item==null?0:item.womanCount)
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    activityNum(data) {
      var myChart = this.$echarts.init(this.$refs.activityNum);
      var option = {
        title: {
          text: '参加活动男女占比',
          left: '20px',
          top: '10px'
        },
        color: ["#00bb7a", "#ff9502"],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          right: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              { value: data[0].manCount, name: '男'},
              { value: data[0].womanCount, name: '女'},
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    scoreNumByScore(data) {
      let list1 = [];
      let list2 = [];
      let list3 = [];
      for (var i = 0; i < data.length; i++) {
        list1.push(data[i].score);
        list2.push(data[i].manCount);
        list3.push(data[i].womanCount);
      }
      var myChart = this.$echarts.init(this.$refs.scoreNumByScore);
      var option = {
        title: {
          text: '活动评分人数占比',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '20px',
          right:'20px',
          textStyle: {
            color: '#000',//字体颜色
          },
          itemHeight: 10,
        },
        color: ["#00bb7a","#ff9502"],
        tooltip: {
          trigger: 'axis',
          axisPointer: {//坐标轴指示器，坐标轴触发有效
            type: 'shadow'//默认为直线，可选为'line'|'shadow'
          },
        },
        xAxis: {
          type: 'value',
          splitLine: {//网格线
            lineStyle: {
              type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
            }
          }
        },
        yAxis: {
          type: 'category',
          nameTextStyle: {//y轴上方单位的颜色
            color: '#000'
          },
          axisLabel: {
            show: true,
            color: '#000',
            fontSize: 12
          },
          data: list1
        },
        series: [
          {type:'bar',name:'男',barWidth:20,data:list2},
          {type:'bar',name:'女',barWidth:20,data:list3}
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize",function(){
        myChart.resize();
      });
    },

    peopleNumByDegree(data) {
      let list1 = [];
      let list2 = [];
      for (var i = 0; i < data.length; i++) {
        list1.push(data[i].degree);
        list2.push(data[i].counts);
      }
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree);
      var option = {
        title: {
          text: '参加活动人员年级统计',
          left: '20px',
          top: '10px',
        },
        xAxis: {
          type: 'category',
          data: list1
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: list2,
            type: 'line',
            lineStyle: {
              color: '#00bb7a',
              width: 2
            },
            symbolSize: 10,
            symbol: 'circle',
            color: '#00bb7a'
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    GetData() {
      let from = {eventKey:this.EventNo}
      this.$Http_Post("/activitymanagement/fxeventplan", {from:from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.DetailsList = res.Data;
        }
      });
    },
  },
  mounted() {
    this.$Http_Post('/certificateTemplate/selected', {templateType:1}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.imgurl = res.Data.templateBack
      } else {
        this.Global.request_failure(res.Message);
      }
    })
    this.EventNo = this.$route.query.id;
    this.GetData();
  },
};
</script>
<style>
.Details .el-tabs{height: 100%;}
.Details .el-tabs__content{height: calc(100% - 80px);}
.Details #pane-review{height: 100%;}
.tabs .title {height: 40px;background-color: rgb(242, 242, 242);border-style: none;border-color: unset;font-size: 14px;padding: 0px;text-align: center;line-height: 20px;font-weight: normal;font-style: normal;border: 1px solid rgb(221, 221, 221);}
.cotent table tr td {border: 1px solid rgb(221, 221, 221);padding-left: 10px;}
.Details {height: 100%;}
.activity_Details {padding: 10px;height: 140px;background-color: #fff;}
.activity_Details .spanstyle {font-family: SourceHanSansSC;font-weight: 400;font-size: 14px;color: rgba(102, 102, 102, 1);font-style: normal;text-decoration: none;letter-spacing: 0px;padding: 10px;}
.activity_Details .spanstyle span {padding: 5px;margin: 10px;font-weight: 700;}
.Details .tabs {height: calc(100% - 200px);padding: 15px;margin-top: 10px;background-color: #fff;}
.Details .certificate{width: 320px;height: 649px;position: fixed;top:110px;left:900px;background-image: url('../../assets/521d753ce444e9fe4055f401cb38784.jpg');background-size: 100% 100%;z-index: -1;}
</style>
